(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@material/floating-label", [], factory);
	else if(typeof exports === 'object')
		exports["floating-label"] = factory();
	else
		root["mdc"] = root["mdc"] || {}, root["mdc"]["floating-label"] = factory();
})(this, function() {
return 